export default __webpack_public_path__ + "static/media/opps-error.7ef90606.png";